module.exports = __webpack_public_path__ + "static/media/Marotte_Noyer_Sepium_MT12-10-Panel.ac505dab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Noyer_Sepium_MT12-10-Panel.jpg
// module id = 959
// module chunks = 37